import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props extends React.PropsWithChildren {
  active: boolean
  className?: string
}

export const FolderContainer: React.FC<Props> = ({
  active,
  className,
  children,
}) => (
  <div className={clsJoin(css.folder_item, active && css.active, className)}>
    {children}
  </div>
)
